import styled, { css } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { Link } from 'react-router-dom';
import Button from '@prisjakt/ui-button';
import HomeDeliveryComponent from '../home-delivery';
import LocationAndCurrencyInfoComponent from '../../../location-and-currency-info';

export const ExpandedInfo = styled.div`
  padding: 1rem;
  display: flex;
  justify-content: space-between;

  @supports (display: grid) {
    display: grid;
    grid-template-columns: 52% 1fr;
  }

  ${media.smallOnly`
      grid-template-columns: 1fr;
  `}

  > div {
    flex: 0 0 48%;

    .sentiment-badge--text > span {
      display: block;
      margin-left: 0;
    }
  }
`;

export const Title = styled.h3`
  margin: 0;
`;

export const StoreLink = styled(Button)`
  text-transform: none;
  padding: 0;
`;

export const PriceInfoRow = styled.span`
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  padding-bottom: 0;

  .pj-ui-price-label {
    color: $text-color;
    padding-top: 1rem;
    padding-right: 1rem;
  }

  ${media.smallOnly`
    display: flex;
  `}
`;

export const StoreLinkWrapper = styled.section(
  props => css`
    grid-area: 2 / 1 / 3 / 3;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    color: ${props.theme.text.linkExternal};
  `
);

export const StoreInfoLink = styled(Link)`
  display: block;
  text-decoration: underline;
  margin-bottom: 1rem;

  &:hover {
    color: ${p => p.theme.text.callToActionHover};
  }
`;

export const StoreInfoRowItem = styled.div`
  margin-bottom: 1rem;
  &:last-child {
    margin-bottom: 0;
  }
`;

export const HomeDelivery = styled(HomeDeliveryComponent)`
  margin-bottom: ${layout.spacing.xSmall};
`;

export const LocationAndCurrencyInfo = styled(LocationAndCurrencyInfoComponent)`
  margin-bottom: ${layout.spacing.small};
`;
